<div class="dasboard-width">
    <div class="row header mar-lft-rgt-0">
        <div class="col-sm-6">FAQ</div>
        <div class="col-sm-6">
            <ol class="breadcrumb cust-bread">
                <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                        class="fa fa-dashboard"></i> Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">FAQ</li>
            </ol>
        </div>
    </div>
    <div class="content mr-top-5">
        <div class="row mar-lft-rgt-0 pad-15">

            <mat-tab-group #tab class="tabset">
                <mat-tab label="Frequently Asked Questions" id="tab1">
                    <mat-accordion class="accord1">
                        <mat-expansion-panel id="panel_{{category.id}}" *ngFor="let category of masterCategory"
                                              (opened)="openGroup(category.id)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="faq-cat">{{category.mastercategory}}</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <hr class="mar-top-0">
                            <ul>
                                <li id = "li_{{category.id}}" >
                                </li>
                            </ul>
                        </mat-expansion-panel>
                    </mat-accordion>
                </mat-tab>
                <mat-tab label="iFIX-Smart Search" id="tab2">
                        <mat-form-field class='search'>
                            <input type="text" matInput [(ngModel)]="searchVal" placeholder="search value"
                                   (input)="searchFaq($event.target.value)" autocomplete="off"
                            >
                        </mat-form-field>
                    <mat-accordion>
                        <mat-expansion-panel id="search_panel_{{data.id}}" *ngFor="let data of searchDtls"
                                             (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div [innerHTML]="data.searchword"></div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p class="answer">{{data.answers}}</p>
                        </mat-expansion-panel>
                    </mat-accordion>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
